export default "__VITE_ASSET__My2PaWsr__"